import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import DevicesIcon from '../../assets/target/images/DevicesHeader.svg';
import DeviceItem from '../../components/DeviceItem';
import PageHeader from '../../components/PageHeader';
import { getDeviceInfo } from '../../hooks/useDeviceInfo';
import { t } from '../../lang';
import HelperService from '../../services/HelperService';
import RequestService from '../../services/RequestService';
import StorageService from '../../services/StorageService';
import './Devices.scss';

const mockDevice = [
	{
		Id: 1,
		MobileUserId: 101,
		Name: 'IPhone',
		Uuid: '6214d4d4f2b7953618f8eeda7fbfa786',
		LastActivity: '',
		IsActiveSession: true,
		DeviceType: 1,
		Created: '',
		Modified: '',
	},
	{
		Id: 2,
		MobileUserId: 101,
		Name: 'Mac',
		Uuid: '6214d4d4f2b7953618f8eeda7fbfa326',
		LastActivity: '',
		IsActiveSession: false,
		DeviceType: 2,
		Created: '',
		Modified: '',
	},
	{
		Id: 3,
		MobileUserId: 101,
		Name: 'Mac',
		Uuid: '6214d4d4f2b7953618f8eeda7fbfa326',
		LastActivity: '',
		IsActiveSession: false,
		DeviceType: 2,
		Created: '',
		Modified: '',
	},
	{
		Id: 4,
		MobileUserId: 101,
		Name: 'Iphone',
		Uuid: '6214d4d4f2b7953618f8eeda7fbfa326',
		LastActivity: '',
		IsActiveSession: false,
		DeviceType: 1,
		Created: '',
		Modified: '',
	},
];

const Devices = () => {
	const devices = useSelector(store => store.app.devices);
	// const [devices, setDevices] = useState();
	const [info, setInfo] = useState();

	useEffect(() => {
		const getInfo = async () => {
			const deviceInfo = await getDeviceInfo();
			const { fingerprintId } = deviceInfo;
			setInfo(fingerprintId);
		};

		// setDevices(mockDevice);
		StorageService.UpdateDevices();
		getInfo();
	}, []);

	const currentDeviceByUuid = devices?.find(d => d.Uuid === info);
	const otherDevicesByUuid = devices
		?.filter(d => d.Uuid !== info)
		.sort((a, b) => new Date(b.LastActivity) - new Date(a.LastActivity));

	const deleteSession = deviceId => {
		HelperService.confirmPin({
			requestMethod: () => RequestService.DeleteDevice(deviceId),
			header: 'Enter PIN',
			subheader: 'PIN is required to confirm this action',
		});
	};

	const deleteAllSession = () => {
		const deviceIds = otherDevicesByUuid.map(item => item.Id);
		const response = RequestService.DeleteDevice(deviceIds);
		return response;
	};

	const terminateAll = () => {
		HelperService.confirmPin({
			requestMethod: deleteAllSession,
			header: 'Enter PIN',
			subheader: 'PIN is required to confirm this action',
		});
	};

	return (
		<>
			<div className='Devices'>
				<PageHeader header='Devices' collapsed={true} />
				<div className='Devices__body'>
					<div className='Devices__body-header FormBlock'>
						<div className='Devices__body-header-image'>
							<img src={DevicesIcon} />
						</div>

						<h2>{t('Devices')}</h2>
						<p>{t('Use your account on multiple devices')}</p>
					</div>

					{currentDeviceByUuid && (
						<div className='Devices__current'>
							<span className='Devices__section-name'>{t('This device')}</span>
							<div className='FormBlock'>
								<DeviceItem
									device={currentDeviceByUuid}
									isCurrent
									showTerminateAll={otherDevicesByUuid.length > 1}
									bottomSeparator={otherDevicesByUuid.length > 1}
									terminateAll={terminateAll}
								/>
							</div>
							{devices.length < 1 && (
								<span className='Devices__section-description'>{t('Logs out all devices except for this one.')}</span>
							)}
						</div>
					)}

					{otherDevicesByUuid?.length !== 0 && (
						<div className='Devices__list'>
							<span className='Devices__section-name'>{t('Active sessions')}</span>
							<div className='FormBlock'>
								{otherDevicesByUuid &&
									otherDevicesByUuid.length > 0 &&
									otherDevicesByUuid?.map((item, index) => (
										<DeviceItem
											device={item}
											bottomSeparator={index !== otherDevicesByUuid.length - 1}
											deleteDevice={deleteSession}
											terminateAll={terminateAll}
										/>
									))}
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Devices;
